import CampaignSettingsUpdateForm from "./CampaignSettingsUpdateForm"

export default CampaignSettingsUpdateForm
